import { render, staticRenderFns } from "./OrderSetView.vue?vue&type=template&id=f18bb388&scoped=true&"
import script from "./OrderSetView.vue?vue&type=script&lang=js&"
export * from "./OrderSetView.vue?vue&type=script&lang=js&"
import style0 from "./OrderSetView.vue?vue&type=style&index=0&id=f18bb388&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f18bb388",
  null
  
)

export default component.exports